export default __webpack_public_path__ + "static/media/bg-polinter-plastics.6c2cb55d.png";